module.exports = __webpack_public_path__ + "img/legacy-shape-4.e9b29a6b.png";